import React from 'react';
import { formatValue, formatConfidence } from '../../utils/formatters';

const GatekeeperSection = ({
    showTopGatekeeperSummary,
    showBottomGatekeeperStatusCard,
    gatekeeperStatus,
    gatekeeperCategory,
    gatekeeperConfidence,
    gatekeeperReason,
    gatekeeperSignals,
    gatekeeperRejected
}) => {
    if (!showTopGatekeeperSummary && !showBottomGatekeeperStatusCard) {
        return null;
    }

    const title = showTopGatekeeperSummary ? 'Gatekeeper Review' : 'Gatekeeper Details';

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>
                {showTopGatekeeperSummary ? 'Gatekeeper Review' : 'Gatekeeper Review'}
            </h4>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '15px'
            }}>
                {showBottomGatekeeperStatusCard && (
                    <div style={{
                        background: gatekeeperStatus.background,
                        border: `1px solid ${gatekeeperStatus.border}`,
                        borderRadius: '12px',
                        padding: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px'
                    }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                            <span style={{
                                color: '#9ca3af',
                                fontSize: '12px',
                                letterSpacing: '0.08em',
                                textTransform: 'uppercase',
                                fontWeight: 600
                            }}>
                                Status
                            </span>
                            <span style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                alignSelf: 'flex-start',
                                backgroundColor: gatekeeperStatus.color,
                                color: '#0b0b0b',
                                padding: '6px 14px',
                                borderRadius: '999px',
                                fontSize: '14px',
                                fontWeight: 600,
                                letterSpacing: '0.4px'
                            }}>
                                {gatekeeperStatus.label}
                            </span>
                        </div>

                        {(gatekeeperCategory || gatekeeperConfidence) && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                {gatekeeperCategory && (
                                    <div>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#a0a0a0',
                                            textTransform: 'uppercase',
                                            marginBottom: '6px',
                                            fontWeight: '600',
                                            letterSpacing: '0.5px'
                                        }}>
                                            Category
                                        </div>
                                        <div style={{
                                            fontSize: '18px',
                                            fontWeight: 600,
                                            color: '#f9fafb'
                                        }}>
                                            {formatValue(gatekeeperCategory)}
                                        </div>
                                    </div>
                                )}

                                {gatekeeperConfidence !== null && gatekeeperConfidence !== undefined && (
                                    <div>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#a0a0a0',
                                            textTransform: 'uppercase',
                                            marginBottom: '6px',
                                            fontWeight: '600',
                                            letterSpacing: '0.5px'
                                        }}>
                                            Confidence
                                        </div>
                                        <div style={{
                                            fontSize: '18px',
                                            fontWeight: 600,
                                            color: '#f9fafb'
                                        }}>
                                            {formatConfidence(gatekeeperConfidence)}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}

                {showTopGatekeeperSummary && (
                    <div
                        style={{
                            background: gatekeeperStatus.background,
                            border: `1px solid ${gatekeeperStatus.border}`,
                            borderRadius: '16px',
                            padding: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '16px'
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <span style={{
                                color: '#9ca3af',
                                fontSize: '12px',
                                letterSpacing: '0.08em',
                                textTransform: 'uppercase',
                                fontWeight: 600
                            }}>
                                Status
                            </span>
                            <span
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    alignSelf: 'flex-start',
                                    padding: '6px 16px',
                                    borderRadius: '999px',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    letterSpacing: '0.4px',
                                    backgroundColor: gatekeeperStatus.color,
                                    color: '#0b0b0b'
                                }}
                            >
                                {gatekeeperStatus.label}
                            </span>
                        </div>

                        {gatekeeperCategory && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                <span style={{
                                    color: '#9ca3af',
                                    fontSize: '12px',
                                    letterSpacing: '0.08em',
                                    textTransform: 'uppercase',
                                    fontWeight: 600
                                }}>
                                    Category
                                </span>
                                <span style={{
                                    fontSize: '18px',
                                    fontWeight: 600,
                                    color: '#f9fafb'
                                }}>
                                    {formatValue(gatekeeperCategory)}
                                </span>
                            </div>
                        )}

                        {gatekeeperConfidence !== null && gatekeeperConfidence !== undefined && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                <span style={{
                                    color: '#9ca3af',
                                    fontSize: '12px',
                                    letterSpacing: '0.08em',
                                    textTransform: 'uppercase',
                                    fontWeight: 600
                                }}>
                                    Confidence
                                </span>
                                <span style={{
                                    fontSize: '18px',
                                    fontWeight: 600,
                                    color: '#f9fafb'
                                }}>
                                    {formatConfidence(gatekeeperConfidence)}
                                </span>
                            </div>
                        )}
                    </div>
                )}

                {gatekeeperReason && (
                    <div style={{
                        backgroundColor: '#2d2d2d',
                        border: `1px solid ${gatekeeperRejected ? 'rgba(248, 113, 113, 0.45)' : '#404040'}`,
                        borderRadius: '12px',
                        padding: '20px',
                        gridColumn: '1 / -1'
                    }}>
                        <h4 style={{
                            margin: '0 0 12px 0',
                            color: '#e0e0e0',
                            fontWeight: '600'
                        }}>
                            Reason
                        </h4>
                        <p style={{
                            margin: 0,
                            color: '#d0d0d0',
                            lineHeight: '1.6',
                            fontSize: '14px'
                        }}>
                            {gatekeeperReason}
                        </p>
                    </div>
                )}

                {gatekeeperSignals.length > 0 && (
                    <div style={{
                        backgroundColor: '#252525',
                        border: '1px solid #333333',
                        borderRadius: '12px',
                        padding: '20px',
                        gridColumn: '1 / -1'
                    }}>
                        <h4 style={{
                            margin: '0 0 12px 0',
                            color: '#e0e0e0',
                            fontWeight: '600'
                        }}>
                            Signals
                        </h4>
                        <ul style={{
                            margin: 0,
                            paddingLeft: '20px',
                            color: '#c0c0c0',
                            lineHeight: '1.7',
                            fontSize: '14px'
                        }}>
                            {gatekeeperSignals.map((signal, index) => (
                                <li key={`${index}-${signal}`}>
                                    {signal}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GatekeeperSection;






